import React, { useEffect, useRef } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { i18n } from "@src/i18n/i18n";
import styles from "./logout.module.scss";

const cssClassName = "logout";
const LOGIN_PATH = "/login";
const SIGN_OUT_PAGE_DURATION_MS = 5000;

export const Logout = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  //TODO: implement when LanguageProvider is ready also for Login and Logout Components
  /* const i18n = useI18N(); */

  const texts = {
    signingOutMessage: i18n("pages.logout.signingOutMessage"),
  };

  // Guard so a React-18 Strict-Mode dev double-mount does not fire the
  // iframe-to-end_session twice (which would hit ZITADEL twice).
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    // Start the 5-second redirect immediately so the user is never stuck on
    // this page even if the iframe hangs. Run signoutSilent in parallel.
    const redirect = setTimeout(
      () => navigate(LOGIN_PATH, { state: { loggedOut: true } }),
      SIGN_OUT_PAGE_DURATION_MS,
    );

    void (async () => {
      try {
        await auth.signoutSilent({ silentRequestTimeoutInSeconds: 5 });
      } catch (error) {
        // The timeout error gets parked on auth.error by react-oidc-context
        // BEFORE this catch runs; the login.tsx filter ignores it on /login.
        console.error("Server-side signout failed", error);
      }
    })();

    return () => clearTimeout(redirect);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles[cssClassName]}>
      <p className={styles[`${cssClassName}__text`]}>
        {texts.signingOutMessage}
      </p>
    </div>
  );
};
